module.exports = __webpack_public_path__ + "static/media/welcomeHeroImage.861ac8c5.png";